<template>
  <div class="content">
    <transition name="bounce">
      <GamesBackDrop v-if="showGames" @close-backdrop="showGames = !showGames" />
      <HowToPlayBackDrop v-if="howToPlay" @close-backdrop="howToPlay = !howToPlay" />
    </transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <install-prompt></install-prompt>
          <h2 class="title" style="margin-bottom: 30px" color>
            {{ $t("home.title") }}
          </h2>
          <base-modal
            :title="modalTitle"
            :message="modalMessage"
            :showModal="showModal"
            @close-modal="showModal = false"
          />
          <div>
            <div id="body">
              <div>
                <h4 style="margin-bottom: 20px" class="title card-title">
                  {{ $t("home.subtitle") }}
                </h4>
                <div class="central-image">
                  <img
                    src="/instagram.jpeg"
                    :alt="$t('home.subtitle')"
                    style="width: 100%"
                  />
                </div>

                <div class="space-evenly" style="margin-bottom: 20px">
                  <button
                    class="btn btn-base btn-fill"
                    @click="showGames = !showGames"
                  >
                    {{ $t("home.games") }}
                  </button>
                  <button
                    class="btn btn-base btn-fill"
                    @click="howToPlay = !howToPlay"
                  >
                    {{ $t("home.howto") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div slot="footer" style="width: 100%">
            <share-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

import Card from "src/components/Cards/Card.vue";
import ShareFooter from "src/components/ShareFooter.vue";
import InstallPrompt from "src/components/InstallPrompt.vue";
import GamesBackDrop from "./GamesBackDrop.vue";
import HowToPlayBackDrop from "src/components/HowToPlayBackDrop.vue";

export default {
  mixins: [mixin],

  components: {
    Card,
    ShareFooter,
    InstallPrompt,
    GamesBackDrop,
    HowToPlayBackDrop
  },

  data() {
    return {
      showModal: false,
      modalTitle: "",
      modalMessage: "",
      showGames: false,
      howToPlay: false,
    };
  },

  created() {
    if (navigator.languages != undefined) console.warn(navigator.languages[0]);
    else console.warn(navigator.language);
    this.enableLotteryCheck();
    window.addEventListener("beforeinstallprompt", function (event) {
      console.log("before install prompt");
      event.prompt();
    });
  },

  beforeDestroy() {
    this.disableLotteryCheck();
  },

  methods: {
    wtf() {
      console.warn("wtf");
      this.showGames = false;
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}

.center {
  justify-content: center;
  display: grid;
}

.space-evenly {
  display: flex;
  justify-content: space-evenly;
}

.central-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin: 0px -20px 30px -20px;
  margin-bottom: 30px;
}

.bounce-enter-active {
  animation: bounce-in 1s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
</style>
